import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\ContractController::store
* @see app/Http/Controllers/Company/ContractController.php:23
* @route '/companies/{company}/contracts'
*/
export const store = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies/{company}/contracts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Company\ContractController::store
* @see app/Http/Controllers/Company/ContractController.php:23
* @route '/companies/{company}/contracts'
*/
store.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\ContractController::store
* @see app/Http/Controllers/Company/ContractController.php:23
* @route '/companies/{company}/contracts'
*/
store.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Company\ContractController::update
* @see app/Http/Controllers/Company/ContractController.php:34
* @route '/companies/{company}/contracts/{contract}'
*/
export const update = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/companies/{company}/contracts/{contract}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\ContractController::update
* @see app/Http/Controllers/Company/ContractController.php:34
* @route '/companies/{company}/contracts/{contract}'
*/
update.url = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            contract: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        contract: typeof args.contract === 'object'
        ? args.contract.id
        : args.contract,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{contract}', parsedArgs.contract.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\ContractController::update
* @see app/Http/Controllers/Company/ContractController.php:34
* @route '/companies/{company}/contracts/{contract}'
*/
update.put = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Company\ContractController::destroy
* @see app/Http/Controllers/Company/ContractController.php:45
* @route '/companies/{company}/contracts/{contract}'
*/
export const destroy = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/companies/{company}/contracts/{contract}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Company\ContractController::destroy
* @see app/Http/Controllers/Company/ContractController.php:45
* @route '/companies/{company}/contracts/{contract}'
*/
destroy.url = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            contract: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        contract: typeof args.contract === 'object'
        ? args.contract.id
        : args.contract,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{contract}', parsedArgs.contract.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\ContractController::destroy
* @see app/Http/Controllers/Company/ContractController.php:45
* @route '/companies/{company}/contracts/{contract}'
*/
destroy.delete = (args: { company: string | { id: string }, contract: string | { id: string } } | [company: string | { id: string }, contract: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const contracts = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default contracts